import Storage from 'vue-ls'

const STORAGE_TOKEN_KEY = 'zendesk-cbm-token'

// One month
const STORAGE_TOKEN_EXPIRATION = 30 * 24 * 60 * 60 * 1000

const options = {
  namespace: 'mf-',
  name: 'ls',
  storage: 'local',
}

const { ls } = Storage.useStorage(options)

export const clearZendeskToken = () => {
  try {
    ls.remove(STORAGE_TOKEN_KEY)
  } catch (error) {
    console.error('[Zendesk]', 'Failed to clear token:', error)
  }
}

export const saveZendeskToken = (token) => {
  try {
    ls.set(STORAGE_TOKEN_KEY, token, STORAGE_TOKEN_EXPIRATION)
  } catch (error) {
    console.error('[Zendesk]', 'Failed to save token:', error)
  }
}

export const loadZendeskToken = () => {
  try {
    return ls.get(STORAGE_TOKEN_KEY)
  } catch (error) {
    console.error('[Zendesk]', 'Failed to load token:', error)
    return null
  }
}
